import { AppShell, NavLink, Image, Flex, Box, Text, Avatar, Divider } from "@mantine/core";
import {
  IconUsers,
  IconReceipt,
  IconTargetArrow,
  IconBell,
  IconDeviceMobile,
  IconUserFilled,
  IconBuildingBank,
  IconFileAnalytics,
  IconServer,
} from "@tabler/icons-react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import trpc from "@/shared/utils/trpc";

const adminNavItems = [
  { label: "Users", icon: IconUsers, path: "/home", activePrefixes: ["/users"] },
  { label: "Orders", icon: IconReceipt, path: "/orders" },
  { label: "Goal & Schemes", icon: IconTargetArrow, path: "/goals" },
  { label: "Asset Based Funds", icon: IconBuildingBank, path: "/asset-based-funds" },
  { label: "Notifications", icon: IconBell, path: "/notifications" },
  { label: "Inflation configuration", icon: IconDeviceMobile, path: "/inflation" },
  { label: "Reconciliation History", icon: IconFileAnalytics, path: "/reconciliation" },
  { label: "Server Configuration", icon: IconServer, path: "/server-config" },
];

export function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path: string, activePrefixes?: string[]) =>
    location.pathname === path ||
    location.pathname.startsWith(`${path}/`) ||
    !!activePrefixes?.some((prefix) => location.pathname.startsWith(prefix));

  const [adminUsername, setAdminUsername] = useState<string | null>(null);

  useEffect(() => {
    trpc.admin.getCurrentAdmin
      .query()
      .then((res) => setAdminUsername(res.data.username))
      .catch(() => {});
  }, []);

  return (
    <AppShell navbar={{ width: 240, breakpoint: "sm" }} padding="0">
      <AppShell.Navbar p="md" style={{ display: "flex", flexDirection: "column" }}>
        {/* Logo */}
        <Flex align="center" gap={10} mb="md" mt={4} px={4}>
          <Image src="/SipLogo.svg" w={24} />
          <Text fw={600} fz="lg" c="dark">
            SiP24Seven
          </Text>
        </Flex>

        {/* Nav items */}
        <Box style={{ flex: 1 }}>
          {adminNavItems.map((item) => (
            <NavLink
              key={item.label}
              label={item.label}
              leftSection={<item.icon size={16} stroke={1.5} />}
              active={isActive(item.path, item.activePrefixes)}
              onClick={() => navigate(item.path)}
              variant="light"
              mb={4}
              style={{ borderRadius: "var(--mantine-radius-md)" }}
            />
          ))}
        </Box>

        {/* Footer */}
        <Box>
          <Text fz="xs" c="slate.4" mb="sm">
            © {new Date().getFullYear()} SiP24Seven.com
          </Text>
          <Divider mb="sm" />
          <Flex align="center" gap={10} onClick={() => navigate("/profile")} style={{ cursor: "pointer", minWidth: 0 }}>
            <Avatar size={36} radius="md" color="#1F68A8" variant="light">
              <IconUserFilled size={20} />
            </Avatar>
            <Text
              fz="sm"
              fw={500}
              c="dark"
              style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
            >
              {adminUsername ?? "—"}
            </Text>
          </Flex>
        </Box>
      </AppShell.Navbar>

      <AppShell.Main style={{ overflow: "hidden", height: "100vh", display: "flex", flexDirection: "column" }}>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
